<div class="d-flex flex-nowrap flex-column flex-sm-row flex-sm-wrap justify-content-center align-items-center m-0 py-3">

  @for (pointer of controlPointer; track pointer; let i = $index) {
    <div class="d-flex flex-sm-column flex-row container-info">
      <div class="d-flex align-items-center py-2 card-container">
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front" [style.background]="pointer.background ?? '#36858a94'">
              <div class="info-container">
                <h4 class="m-0">{{i == 0 ? 'Punto origen' : i == controlPointer.length - 1 ? 'Punto Fin' : i}}</h4>
              </div>
            </div>
            <div class="flip-card-back" [style.background]="pointer.background ?? '#36858a94'">
              @if (pointer.buttonsType?.includes(1)) {
                <div (click)='$selectPointer(i, pointer)' matTooltip="Registrar"
                  matTooltipPosition="above">
                  <i class="fa fa-plus-square btn-accion" style="cursor: pointer; font-size: 20px"></i>
                </div>
              }
              @if (pointer.buttonsType?.includes(2)) {
                <div (click)='editCard(pointer)' matTooltip="Editar"
                  matTooltipPosition="above">
                  <i class="fa fa-edit btn-accion" style="cursor: pointer; font-size: 20px;"></i>
                </div>
              }
              @if (pointer.buttonsType?.includes(3)) {
                <div (click)='deleteCard(i, pointer)' matTooltip="Eliminar"
                  matTooltipPosition="above">
                  <i class="fa fa-trash btn-accion" style="cursor: pointer; font-size: 20px"></i>
                </div>
              }
              @if (pointer.buttonsType?.includes(4) && pointer.background != '#d18888') {
                <div (click)='viewDetail(i, pointer)' matTooltip="Detalle"
                  matTooltipPosition="above">
                  <i class="fa fa-eye btn-accion" style="cursor: pointer; font-size: 20px"></i>
                </div>
              }
            </div>
          </div>
          @if (i != controlPointer.length - 1) {
            <div class="d-sm-none d-flex flex-column">
              <div [ngClass]="{'linea-vertical-complete': controlPointer[i+1]?.complete || isHistorical, 'linea-vertical': !controlPointer[i+1]?.complete}"></div>
              @if (viewAddCkeckpoint && !controlPointer[i+1].complete) {
                <div class="d-flex justify-content-center align-items-center">
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="addCheckpointDialog(i)"
                    matTooltip="Punto de control intermedio"
                    style="width: 30px; height: 30px; min-width: 30px;"
                    >
                    <mat-icon style="font-size: 16px;">add_location_alt</mat-icon>
                  </button>
                </div>
              }
              <div [ngClass]="{'linea-vertical-complete': controlPointer[i+1]?.complete || isHistorical, 'linea-vertical': !controlPointer[i+1]?.complete}"></div>
            </div>
          }
        </div>
        @if (i != controlPointer.length - 1) {
          <div
            class="d-none d-sm-flex align-items-sm-center"
            >
            <div class="line"></div>
            @if (viewAddCkeckpoint && !controlPointer[i+1].background) {
              <div class="d-flex justify-content-center align-items-center">
                <button
                  mat-mini-fab
                  color="primary"
                  (click)="addCheckpointDialog(i)"
                  matTooltip="Punto de control intermedio"
                  >
                  <mat-icon>add_location_alt</mat-icon>
                </button>
              </div>
            }
            <div class="line"></div>
          </div>
        }
      </div>
      <div class="description-container d-flex">
        <div class="description">
          <h5 class="m-0 text-center">{{pointer.date | dateFormat}}</h5>
          <h3 class="m-0">{{pointer.name}}</h3>
        </div>
      </div>
    </div>
  }

</div>

@if (!isRoute) {
  <div class="color-code-container">
    <div class="color-code">
      <span class="color-box" [style.background]="colorComplete"></span>
      <span>Completo</span>
    </div>
    <div class="color-code">
      <span class="color-box" [style.background]="colorIncomplete"></span>
      <span>Incompleto</span>
    </div>
    @if (!isHistorical) {
      <div class="color-code">
        <span class="color-box" [style.background]="colorPending"></span>
        <span>Pendiente</span>
      </div>
    }
  </div>
}
